import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error("Failed to find the root element");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
	<BrowserRouter>
		<ConfigProvider locale={ruRU}>
			<App />
		</ConfigProvider>
	</BrowserRouter>
);

reportWebVitals();
